"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Replacement_1 = require("./Replacement");

var Replacer = function () {
  function Replacer(textNode) {
    this.next = null;
    this.replacements = [];
    this.replacedNodes = [];
    this.textNode = textNode;
  }

  Replacer.prototype.addReplacement = function (replacement) {
    if (this.replacements.length === 0) {
      if (replacement.range.start > 0) {
        var front = new Replacement_1.Replacement(this.textNode.nodeValue);
        front.range = {
          start: 0,
          end: replacement.range.start
        };
        this.replacements.push(front);
      }
    } else {
      var last = this.replacements[this.replacements.length - 1];

      if (replacement.range.start - last.range.end > 0) {
        var middle = new Replacement_1.Replacement(this.textNode.nodeValue);
        middle.range = {
          start: last.range.end,
          end: replacement.range.start
        };
        this.replacements.push(middle);
      } else if (replacement.range.start - last.range.end < 0) {
        throw "Can't add replacement if replacement.range.start is less than last added replacement.range.end";
      }
    }

    this.replacements.push(replacement);
  };

  Replacer.prototype.replace = function () {
    var last = this.replacements[this.replacements.length - 1];
    var additionalReplacements = [];

    if (last.range.end < this.textNode.nodeValue.length) {
      var rear = new Replacement_1.Replacement(this.textNode.nodeValue);
      rear.range = {
        start: last.range.end,
        end: this.textNode.nodeValue.length
      };
      additionalReplacements.push(rear);
    }

    var replacedNodes = this.replacements.concat(additionalReplacements).reduce(function (nodes, replacement) {
      var node = replacement.replace();

      if (!node) {
        return nodes;
      }

      nodes.push(node);
      return nodes;
    }, []);
    this.replacedNodes = replacedNodes;

    if (!this.textNode.parentNode) {
      return;
    }

    this.textNode.parentNode.replaceChild(replacedNodes.reduce(function (fragment, replacedNode) {
      fragment.appendChild(replacedNode);
      return fragment;
    }, document.createDocumentFragment()), this.textNode);
  };

  Replacer.prototype.recover = function () {
    var recovered = false;

    for (var i = 0; i < this.replacedNodes.length; i++) {
      var replacedNode = this.replacedNodes[i];

      try {
        var parentNode = replacedNode.parentNode;

        if (!parentNode) {
          continue;
        }

        if (!recovered) {
          parentNode.replaceChild(this.textNode, replacedNode);
          recovered = true;
        } else {
          parentNode.removeChild(replacedNode);
        }
      } catch (e) {
        console.error("You might have changed dom node so that we can't recover");
      }
    }
  };

  return Replacer;
}();

exports.Replacer = Replacer;